import produce from "immer";

import * as actionTypes from '../actions/actionTypes';

const initialState = {
    date: new Date(),
    count_today: '',
    count_tomorrow: '',
    count_dayPlus2: '',
    count_dayPlus3: '',
    count_WL: null,
    count_all: '',
    count_thisMonth: '',
    count_nextMonth: '',
    count_thisWeek: '',
    count_nextWeek: '',
    count_next30days: '',
    admissions: [],
    hospitalId: null, // hospital the loaded admissions belong to
    keyword: false,
    sortColumn: '-',
    sortMode: '-',
    groupType: false,
    groupId: false,
    subfilters: {},
    page: 1, // for now, filter and page are supported for groups only
    filter: 0,
    dev_suggestedDate: null,
    dev_suggestedAdmission: null,
    extraColumns: {
        ids: false,
        ifcPaymentAmount: false,
    },
    extraColumnIdsSort: 'id',
}

const extraColumnIdsSortCycle = {
    id: 'URNumber',
    URNumber: 'ADMNumber',
    ADMNumber: 'id',
}

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.AUTH_SELECT_HOSPITAL: {
            // Every row carries a manager_customUI map keyed by the customUI ids of
            // the hospital it was loaded for, while the columns are rendered from
            // auth.selectedHospital, which switches immediately. Keeping the old rows
            // until the reload request comes back means rendering them against a
            // foreign set of columns - drop them right away instead (IMP-889).
            const hospitalId = parseInt(action.id);
            if (state.hospitalId === hospitalId) {
                return state;
            }
            return {
                ...state,
                hospitalId,
                admissions: [],
            };
        }
        case actionTypes.ADMISSIONS_LIST_SET_DATE:
            return {
                ...state,
                date: action.date,
                groupType: false,
                groupId: false,
            };
        case actionTypes.ADMISSIONS_LIST_SET_PAGE:
            return {
                ...state,
                page: action.page
            }
        case actionTypes.ADMISSIONS_LIST_SET_GROUP:
            return {
                ...state,
                groupType: action.groupType,
                groupId: action.groupId,
                filter: action.filter,
                page: action.page,
                sortColumn: action.sortColumn,
                sortMode: action.sortMode,
            };
        case actionTypes.ADMISSIONS_LIST_SET_SORT:
            return {
                ...state,
                sortColumn: action.sortColumn,
                sortMode: action.sortMode,
            };
        case actionTypes.ADMISSIONS_LIST_SET_KEYWORD:
            return {
                ...state,
                keyword: action.keyword,
                groupType: false,
                groupId: false,
            };
        case actionTypes.ADMISSIONS_LIST_SET:
            return {
                ...state,
                // page: 1,
                totalPages: null,
                ...action
            };

        case actionTypes.SUBFILTER_SET:
            return produce(state, draft => {
                draft.subfilters[action.subfilter] = action.value;
            });
        case actionTypes.SUBFILTER_RESET:
            return produce(state, draft => {
                draft.subfilters = {};
            });
        case actionTypes.ADMISSIONS_LIST_TOGGLE_EXTRA_COLUMN:
            return {
                ...state,
                extraColumns: {
                    ...state.extraColumns,
                    [action.column]: !state.extraColumns[action.column],
                },
            };
        case actionTypes.ADMISSIONS_LIST_CYCLE_EXTRA_COLUMN_IDS_SORT:
            return {
                ...state,
                extraColumnIdsSort: extraColumnIdsSortCycle[state.extraColumnIdsSort] || 'id',
            };
        case actionTypes.ADMISSION_UPDATE:
            if (state.admissions.length) {
                return produce(state, draft => {
                    const key = Object.keys(state.admissions).find(item => state.admissions[item].id === action.admission.id);
                    draft.admissions[key] = action.admission;
                });
            }
            return state;
        default:
            return state;
    }
}

export default reducer;